<template>
  <v-navigation-drawer
      app
      clipped
      v-model="LEFT_FACILITY_DRAWER_STATE"
      :mini-variant="isMini"
      permanent
      mini-variant-width="50"
      :class="{'drawer-mini': !LEFT_FACILITY_DRAWER_STATE}"
      class="mt-15 pb-15 mt-md-16 pb-md-16"
      width="400"
  >
    <div v-show="!isMini" class="text-right">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs}">
          <v-btn class="pa-5" icon @click.stop="TOOGLE_LEFT_FACILITY_DRAWER_STATE" v-bind="attrs" v-on="on">
            <v-icon color="primary">close</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('buttons:close-sidebar')}}</span>
      </v-tooltip>
    </div>
    <div v-show="isMini" class="text-center">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs}">
          <v-btn class="pa-5" icon @click.stop="TOOGLE_LEFT_FACILITY_DRAWER_STATE" v-bind="attrs" v-on="on">
            <v-icon color="primary">edit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('buttons:open-sidebar')}}</span>
      </v-tooltip>
    </div>

    <!-- Facility Name + Building Name -->
    <v-row v-show="!isMini" align="center" class="px-5">
      <v-col cols="12" lg="3">
        <v-img height="32" contain v-if="facility.typeIconUrl" :src="facility.typeIconUrl"></v-img>
        <v-icon v-else class="sidebar-icon sidebar-icon-bg-light-blue" color="primary">apartment</v-icon>
      </v-col>
      <v-col>
        <h5 class="mb-0 font-weight-bold">
          <v-tooltip v-if="facility.cutName" bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                {{ facility.cutName }}
              </span>
            </template>
            {{ facility.cutName }}
          </v-tooltip>
          <span v-else>{{ facility.name }}</span>
        </h5>
        <h6 class="mb-0">{{ building.name }}</h6>
      </v-col>
    </v-row>

    <v-form ref="form">
      <v-row v-show="!isMini" class="px-5" align="center">
        <v-col cols="12" class="pb-0">
          <!-- Name -->
          <v-text-field
              outlined
              v-model="facility.name"
              :label="$t('common:name')"
              :rules="[ruleRequired($t('utils:rules.required'))]"
              clearable
              tabindex="201"
          />

          <!-- Building -->
          <v-select
              :items="restBuilding"
              item-text="name"
              item-value="id"
              :menu-props="{ bottom: true, offsetY: true }"
              v-model="facility.building"
              outlined
              :label="$t('common:building')"
              clearable
              :rules="[ruleRequired($t('utils:rules.required'))]"
              tabindex="202"
          />

          <!-- Objectnumber -->
          <v-text-field
              outlined
              v-model="facility.objectNumber"
              :label="$t('common:facility-number')"
              clearable
              tabindex="203"
          />

          <!-- FacilityType -->
          <v-select
              :items="restFacilityTypes"
              item-text="name"
              item-value="id"
              :menu-props="{ bottom: true, offsetY: true }"
              v-model="facility.type"
              outlined
              :label="$t('book/facility:common.facility-type')"
              clearable
              :rules="[ruleRequired($t('utils:rules.required'))]"
              tabindex="204"
          >
            <template v-slot:item="{item}">
              {{ item.name }}
              <v-spacer></v-spacer>
              <v-menu
                  open-on-hover
                  top
                  offset-x
                  max-width="300"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    icon
                  >
                    <v-icon>help_outline</v-icon>
                  </v-btn>
                </template>


                <v-list class="pa-0">
                  <v-list-item>
                    {{ item.description }}
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-select>

          <!-- Stairway -->
          <v-text-field
              outlined
              v-model="facility.stairway"
              :label="$t('book/facility:common.stairway')"
              clearable
              tabindex="205"
          />

          <!-- Manager -->
          <CustomerTypeahead v-if="isAdmin"
              ref="managerTypeahead"
              :value="facility.manager"
              @input="facility.manager = $event"
              :label="$t('book/facility:common.manager')"
              tabindex="206"
          />
          <!-- Manager for non-admins: customer or sub-customer may be selected-->
          <v-select v-else
              ref="managerSelect"
              v-model="facility.manager"
              :items="selectableCustomers"
              item-text="name"
              item-value="id"
              :menu-props="{ bottom: true, offsetY: true }"
              outlined
              :label="$t('book/facility:common.manager')"
              clearable
              :rules="[ruleRequired($t('utils:rules.required'))]"
              :disabled="selectableCustomers.length === 1"
              tabindex="206"
          />
          <!-- public access flag -->
          <!--
          <v-checkbox
              color="secondary"
              v-model="facility.publicProcessAccess"
              :label="$t('book/facility:common.public-access')"
          />
          -->

          <v-select
              v-if="isAdmin"
              :items="restDisplay"
              item-value="key"
              item-text="value"
              :menu-props="{ bottom: true, offsetY: true }"
              v-model="facility.displayId"
              outlined
              :label="$t('book/facility:common.display')"
              clearable
              :tabindex="isAdmin ? '207' : ''"
          />

          <div class="mb-6" v-if="facility.displayId">
            <BaseButton
                class="white--text"
                color="primary"
                :btnText="$t('common:goto-io-module')"
                icon="monitor"
                @clickedButton="$router.push(`/${$store.state.manager.displayModuleUrl}/elevator?elevatorId=${facility.displayId}`)"
            />
          </div>

          <!-- QR-Code-Select -->
          <v-select
              v-if="isAdmin"
              :items="restQRCodes"
              item-value="id"
              item-text="name"
              :menu-props="{ bottom: true, offsetY: true }"
              v-model="facility.qrcode"
              outlined
              :label="$t('common:qr-code_plural')"
              clearable
              :tabindex="isAdmin ? '208' : ''"
          />

          <!-- Btn to generate a new QR-Code or show an existing one-->
          <BaseButton v-if="facility.qrcode == null"
              ref="generateQRCodeBtn"
              class="white--text"
              color="primary"
              :btnText="$t('book/facility:facility.form-sidebar.generateqr-btn-text')"
              @clickedButton="handleQRCode"
              icon="qr_code"
              tabindex="209"
          />
          <BaseButton v-else
              ref="generateQRCodeBtn"
              class="white--text"
              color="primary"
              :btnText="$t('book/facility:facility.form-sidebar.showqrcode-btn-text')"
              @clickedButton="handleQRCode"
              icon="qr_code"
              tabindex="209"
          />
          <QRCodeShowForm
            ref="qRCodeShowForm"
          />

          <v-container>
            <v-row>
              <v-col col="12">
                <v-checkbox
                    ref="toggleFullServiceCheckbox"
                    v-if="isAdmin"
                    color="secondary"
                    v-model="facility.fullService"
                    :label="$t('book/facility:common.full-service')"
                    :disabled="isPOAProcessing"
                    @change="onClickFullService($event)"
                    tabindex="210"
                />
              </v-col>
            </v-row>
            <v-row>
              <span ref = "infoTextStoreFacility" v-if="isAdmin && pOATextVisible" style="visibility: visible; color:red" >
                {{ $t('book/facility:facility.form-sidebar.fullService-storefirst-btn-text') }}
              </span>
            </v-row>
          </v-container>

          <BaseButton  v-if="facility.fullService"
              color="primary"
              :btnText="$t('book/facility:facility.form-sidebar.poa-generate-btn')"
              @clickedButton="openEMailPOADialog()"
              :class="!isAdmin ? 'mt-4' : ''"
              :disabled="this.pOATextVisible"
              tabindex="211"
          />

          <OpenStreetMap
              class="mt-4"
              ref="map"
              :lat="building.latitude"
              :long="building.longitude"
              height="250"
              tabindex="212"
          ></OpenStreetMap>
        </v-col>
        <v-col cols="12" class="pb-0 pt-5">
          <BaseButton
              color="primary"
              :btnText="$t('buttons:save-changes')"
              tabindex="213"
              @clickedButton="updateForm"/>
        </v-col>
        <v-col cols="12">
          <TwoButtonDialog
              v-if="restore"
              ref="restoreButton"
              :btn-text="$t('buttons:restore')"
              color="green"
              :dialog-title="$t('dialog:restore-btn-title', {name : $t('book/facility:facility.form-sidebar.dialog-part-1')})"
              :dialog-text="$t('dialog:restore-btn-dialog', {name : $t('book/facility:facility.form-sidebar.dialog-part-2')})"
              :button1-text="$t('buttons:restore')"
              :button2-text="$t('buttons:cancel')"
              @clickedButton1="restoreFacility()"
              @clickedButton2="$refs.restoreButton.showDialog = false"
          />

          <ThreeButtonDialog
              ref="adminDeleteButton"
              v-if="isAdmin"
              color="errorDark"
              :btn-text="$t('buttons:delete')"
              :dialog-title="$t('dialog:delete-btn-title', {name : $t('book/facility:facility.form-sidebar.dialog-part-1')})"
              :dialog-text="$t('dialog:delete-btn-dialog', {name : $t('book/facility:facility.form-sidebar.dialog-part-2')})"
              :button1-text="$t('dialog:delete-btn-3-text')"
              :button2-text="$t('buttons:cancel')"
              :button3-text="$t('buttons:delete')"
              :hideFirstButton="restore"
              @clickedButton1="deleteFacility(true)"
              @clickedButton2="$refs.adminDeleteButton.showDialog = false;"
              @clickedButton3="deleteFacility(false)"
          />

          <TwoButtonDialog
              v-if="!isAdmin"
              ref="deleteButton"
              :btn-text="$t('buttons:delete')"
              color="errorDark"
              :dialog-title="$t('dialog:delete-btn-title', {name : $t('book/facility:facility.form-sidebar.dialog-part-1')})"
              :dialog-text="$t('dialog:delete-btn-dialog', {name : $t('book/facility:facility.form-sidebar.dialog-part-2')})"
              :button1-text="$t('buttons:cancel')"
              :button2-text="$t('buttons:delete')"
              @clickedButton1="$refs.deleteButton.showDialog = false"
              @clickedButton2="deleteFacility(true)"
          />

          <EMailSendConfirmationDialog
              ref="toggleButtonMessage"
              color="errorDark"
              :dialog-title="$t('book/facility:facility.form-sidebar.poa-dialog.btn-text')"
              :dialog-text="$t('book/facility:facility.form-sidebar.poa-dialog.title')"
              :button1-text="$t('buttons:cancel')"
              :button2-text="$t('book/facility:facility.form-sidebar.poa-dialog.generate')"
              @clickedButton2="toggleFullServiceFlag()"
              addTextField
              :addTextFieldLabel="$t('common:email')"
              :addTextFieldLastNameLabel="$t('book/facility:facility.form-sidebar.poa-dialog.label')"
          />
        </v-col>
      </v-row>
      <DocumentViewer ref="documentViewer"/>
    </v-form>

  </v-navigation-drawer>

</template>

<script>
import QRCodeService from "@/modules/book/services/qrcode-service";
import BuildingService from "@/modules/book/services/building-service";
import FacilityService from "@/modules/book/services/facility-service";
import FacilityTypeService from "@/modules/book/services/facility-type-service";

import Utils from "@/modules/core/services/utils";
import DataUtils from "@/modules/core/services/data-utils";
import {ruleRequired} from "@/modules/core/services/rules";
import GPSUtils from "@/modules/core/services/gps-utils";

import Facility from "@/modules/book/data/facility";
import Building from "@/modules/book/data/building";
import QRCode from '@/modules/book/data/qrcode'
import FacilityType from '@/modules/book/data/facility-type';

import CustomerTypeahead from "@/modules/core/components/CustomerTypeAhead";
import TwoButtonDialog from "@/modules/core/components/TwoButtonDialog/TwoButtonDialog";
import ThreeButtonDialog from "@/modules/core/components/TwoButtonDialog/ThreeButtonDialog";
import BaseButton from "@/modules/core/components/Base/BaseButton";
import EMailSendConfirmationDialog
  from "@/modules/core/components/EMailSendConfirmationDialog/EMailSendConfirmationDialog";

import QRCodeShowForm from "@/modules/book/views/admin/qrcode/QRCodeShowForm"

import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'
import PdfGeneratorService from "@/modules/book/services/PdfGeneratorService";
import CustomerService from "@/modules/core/services/customer-service";
import Customer from "@/modules/core/data/customer";
import DocumentViewer from "@/modules/core/components/DocumentViewer/DocumentViewer";
import DocumentationService from "@/modules/core/services/documentation-service";

export default {
  name: 'FacilityFormSidebar',
  components: {
    CustomerTypeahead,
    OpenStreetMap: () => import('@/modules/core/components/OpenStreetMap/OpenStreetMap'),
    TwoButtonDialog,
    ThreeButtonDialog,
    BaseButton,
    QRCodeShowForm,
    EMailSendConfirmationDialog,
    DocumentViewer
  },
  data() {
    return {
      facility: new Facility(),
      building: new Building(),

      restore: false,

      restBuilding: [],
      restDisplay: [],
      restQRCodes: [],
      restFacilityTypes: [],
      isPOAProcessing: false,
      pOATextVisible: false,
      selectableCustomers: []
    }
  },
  computed: {
    ...mapState('book/layout', {
      leftFacilityDrawer: state => state.leftFacilityDrawer
    }),
    ...mapGetters('auth', ['isAdmin']),
    LEFT_FACILITY_DRAWER_STATE: {
      get() {
        return this.leftFacilityDrawer
      },
      set(newValue) {
        if (newValue === this.leftFacilityDrawer) return;
        this.TOOGLE_LEFT_FACILITY_DRAWER_STATE();
      }
    },
    // property to determine if mini drawer is active
    isMini() {
      if(this.$vuetify.breakpoint.mdAndDown) {
        return this.LEFT_FACILITY_DRAWER_STATE
      } else {
        return !this.LEFT_FACILITY_DRAWER_STATE
      }
    },
    currentLang() {
      return this.$store.state.translation.language;
    },
  },
  watch: {
    currentLang() {
      Utils.sleep(500).then(() => {
        this.$refs.form.resetValidation()
      })
    },
    'facility.type'(newType) {
      if (Array.isArray(this.restFacilityTypes) && !this.restFacilityTypes.length) {
        return;
      }
      const type = this.restFacilityTypes.find(type => type.id === newType)
      if (type) {
        this.setFacilityInfoTabs(type.dataTabs)
      }
    },
    'restFacilityTypes'() {
      const type = this.restFacilityTypes.find(type => type.id === this.facility.type)
      if (type) {
        this.setFacilityInfoTabs(type.dataTabs)
      }
    }
  },
  methods: {
    ...mapMutations('book/layout', ['setFacilityInfoTabs']),
    ...mapActions(
        'book/layout', ['TOOGLE_LEFT_FACILITY_DRAWER_STATE']
    ),

    openEMailPOADialog() {
      this.$refs.toggleButtonMessage.showDialog = true;
      this.$refs.toggleButtonMessage.textField = this.customer.contactMail;
      this.$refs.toggleButtonMessage.textFieldLastName = this.customer.contactName;
    },

    onClickFullService(e) {
      if (e) {
        this.pOATextVisible = true;
      }
      else
        this.pOATextVisible = false;
    },
    /**
     * Click handler for checkbox to create poa documentation
     */
    toggleFullServiceFlag() {

      if (this.facility.fullService) {

        let senderEMailAddress = this.$refs.toggleButtonMessage.textField;
        let senderLastName = this.$refs.toggleButtonMessage.textFieldLastName;

        this.isPOAProcessing = true;

        PdfGeneratorService.createAndSignPOA(
            this.facility.id,
            senderEMailAddress,
            senderLastName,
            (data) => {
              DocumentationService.readInfoFromApi(data.data,
                  (result) => {
                    this.$refs.documentViewer.currentDoc = result.data;
                  },
                  (error) => {
                    this.$logger.error("Could not load poa document because: " + error);
                    Utils.showFailureSnackbar(this.$t('snackbar:load-failure', { name: this.$t('common:document')}))
                  }
              );
            },
            () => {
              Utils.showFailureSnackbar(this.$t('book/facility:facility.form-sidebar.snackbar.snackbar-poa-generation-error'));
            }
        )
        this.isPOAProcessing = false;
      }
    },
    handleQRCode() {

      if (this.facility.id != null && this.facility.qrcode == null) {

        FacilityService.createSingleQRCode(this.facility.id, this.facility.name,
          (data) => {
            this.facility.qrcode = data.data.id;

            this.$refs.qRCodeShowForm.facilityId = data.data.code;
            this.restQRCodes.push(data.data);

            Utils.showSuccessSnackbar(this.$t('book/facility:facility.form-sidebar.snackbar.snackbar-success'));
          },
          () => {
            Utils.showFailureSnackbar(this.$t('book/facility:facility.form-sidebar.snackbar.snackbar-failure'));
          }
        );

        this.$refs.qRCodeShowForm.showDialog = true;

      } else if (this.facility.id != null){
        this.$refs.qRCodeShowForm.showDialog = true;

        QRCodeService.readFromAPI(this.facility.qrcode,
          (data) => {
            this.$refs.qRCodeShowForm.facilityId = data.data.code;
          },
          () => {
            Utils.showFailureSnackbar(this.$t('book/facility:facility.form-sidebar.snackbar.snackbar-failure'));
          }
        );
      }
    },
    deleteFacility(softDelete) {

      if (this.isAdmin) {
        this.$refs.adminDeleteButton.setButtonSettings(true, true, false, true);
      } else {
        this.$refs.deleteButton.setButtonSettings(true, true, false, true);
      }

      FacilityService.deleteFromAPI(this.facility, softDelete,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('common:facility')}));
          this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/facilities`);
        },
        () => {
          if (this.isAdmin) {
            this.$refs.adminDeleteButton.setButtonSettings(false, false, false, false);
            this.$refs.adminDeleteButton.showDialog = false;
          } else {
            this.$refs.deleteButton.setButtonSettings(false, false, false, false);
            this.$refs.deleteButton.showDialog = false;
          }
          Utils.showFailureSnackbar(this.$t('snackbar:delete-failure', {name: this.$t('common:facility')}))
        }
      )
    },

    restoreFacility() {
      this.$refs.restoreButton.setButtonSettings(true, true, false, true);

      FacilityService.restoreFromApi(this.facility,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:restore-success', {name: this.$t('common:facility')}));
          this.$refs.restoreButton.showDialog = false;
          this.restore = false;
          this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/facilities`);
        },
        () => {
          this.$refs.restoreButton.setButtonSettings(false, false, false, false);
          this.$refs.restoreButton.showDialog = false;
          Utils.showFailureSnackbar(this.$t('snackbar:restore-failure', {name: this.$t('common:facility')}))
        }
      )
    },

    addressToCoordinates() {
      GPSUtils.convertAddressToCoordinates(this.building.address_street, this.building.address_zip, this.building.address_city,
        (res) => {
          if(res.data.length > 0) {
            this.building.latitude = res.data[0].lat;
            this.building.longitude = res.data[0].lon
            if(this.$refs.map) {
              this.$refs.map.recenterMap(res.data[0].lat, res.data[0].lon);
              this.$refs.map.refreshMap();
            }
          } else {
            GPSUtils.getCoordinatesByZipCity(this.building.address_zip, this.building.address_city,
              (resp) => {
                if(resp.data.length > 0) {
                  this.building.latitude = resp.data[0].lat;
                  this.building.longitude = resp.data[0].lon
                  if(this.$refs.map) {
                    this.$refs.map.recenterMap(resp.data[0].lat, resp.data[0].lon);
                    this.$refs.map.refreshMap();
                  }
                } else {
                  Utils.showFailureSnackbar(this.$t('book/facility:facility.form-sidebar.snackbar.gps-search'));
                }
              }
            )
          }
        },
        () => {
          Utils.showFailureSnackbar(this.$t('book/facility:facility.form-sidebar.snackbar.gps-search'));
        }
      )
    },

    setFacilityFormSidebarData(facility, building, loggedInCustomer) {

      FacilityTypeService.readAllFromAPI(
          (res) => {
            this.restFacilityTypes = DataUtils.parseDataToObjectArray(res.data, FacilityType);
          },
          (error) => {
            this.$logger.error("Error at fetching all facility types: " + error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:common.facility-type_plural')}))
          }
      )

      this.facility = facility;
      if (facility.typeIconUrl) {
        facility.typeIconUrl = process.env.VUE_APP_ROOT_HOST + facility.typeIconUrl;
      }

      this.restore = this.facility.deleted;
      this.building = building;

      if (!this.building.latitude && !this.building.longitude && this.building.address_street && this.building.address_zip && this.building.address_city) {
        this.addressToCoordinates();
      }

      if(this.$refs.managerTypeahead) {
        this.$refs.managerTypeahead.initialise(this.facility.manager);
      }
      if (!this.isAdmin && loggedInCustomer) {
        this.selectableCustomers = [ {id:loggedInCustomer.id, name:loggedInCustomer.name}];
        this.selectableCustomers.push(...loggedInCustomer.descendants)
      }

      BuildingService.readAllFromAPI(
        (res) => {
          this.restBuilding = DataUtils.parseDataToObjectArray(res.data, Building);
        },
        (error) => {
          this.$logger.error("Error at fetching all buildings: " + error);
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:common.building-data')}))
        }
      )

      //admins may load and access display and QR code information
      if (this.isAdmin) {
        FacilityService.readDisplays(
          (res) => {
            this.restDisplay = res.data;
          },
          (error) => {
            this.$logger.error("Error at fetching displays: " + error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:common.display_plural')}))
          }
        )
        QRCodeService.readAllUnusedFromAPI(this.facility.id,
          (res) => {
            this.restQRCodes = DataUtils.parseDataToObjectArray(res.data, QRCode);
          },
          (error) => {
            this.$logger.error("Error at fetching QR-Codes: " + error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:qr-code_plural')}))
          }
        )
      }
      if(this.$refs.toggleButtonMessage) {
        this.getCustomerEMail();
      }
    },

    updateForm() {
      if (!this.$refs.form.validate()) {
        Utils.showWarningSnackbar(this.$t('snackbar:empty-fields'))
        return;
      }

      FacilityService.putToAPI(this.facility,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('common:facility')}));
          this.$router.push(this.$store.state.book.routes.lastMainRoute)
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('common:facility')}))
        }
      )
    },
    getCustomerEMail() {
      CustomerService.readFromAPI(this.building.owner,
          (res) => {
            this.customer = DataUtils.parseDataToSingleObject(res.data, Customer);
            this.$refs.toggleButtonMessage.textField = this.customer.contactMail;
            this.$refs.toggleButtonMessage.textFieldLastName = this.customer.contactName;
          },
          null
      )
    },
    ruleRequired
  }
}
</script>
